<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFlipCamera_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M13 3h-1.5l-.724-1.447A.998.998 0 0 0 9.882 1H6.118a.998.998 0 0 0-.894.553L4.5 3H3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2ZM4.235 9.801 2.467 8.033a.374.374 0 0 1 .432-.601l1.103.548A4.003 4.003 0 0 1 8 4c.926 0 1.776.32 2.453.852a.495.495 0 0 1 .002.764.491.491 0 0 1-.619.014A2.987 2.987 0 0 0 8 5a3.002 3.002 0 0 0-2.998 2.977L6.1 7.431a.375.375 0 0 1 .432.602L4.765 9.801a.375.375 0 0 1-.53 0Zm9.337-1.35a.376.376 0 0 1-.472.117l-1.102-.548A4.003 4.003 0 0 1 8 12c-.926 0-1.776-.32-2.453-.852a.495.495 0 0 1-.002-.764.491.491 0 0 1 .619-.014c.508.394 1.145.63 1.836.63a3.002 3.002 0 0 0 2.998-2.977l-1.099.545a.375.375 0 0 1-.431-.601l1.768-1.768a.385.385 0 0 1 .53 0l1.768 1.768c.129.13.145.335.038.484Z"
    />
</svg>
